<template>
  <div class="solution">
    <div class="container">
      <div class="title">{{ $t('solution.titulo') }}</div>
      <div class="subtitle">{{ $t('solution.subtitulo') }}</div>
      <div class="box-container">

        <div class="box">
          <div class="title">{{ $t('solution.bloque1.titulo') }}</div>
          <div class="box-content">
            <div>
              <i class="fas fa-house text-verde"></i>
              <span>{{ $t('solution.bloque1.dato1') }}</span>
            </div>
            <div>
              <i class="fas fa-wheelchair text-verde"></i>
              <span>{{ $t('solution.bloque1.dato2') }}</span>
            </div>
            <div>
              <i class="fas fa-video text-verde"></i>
              <span>{{ $t('solution.bloque1.dato3') }}</span>
            </div>
          </div>
        </div>

        <div class="box">
          <div class="title">{{ $t('solution.bloque2.titulo') }}</div>
          <div class="box-content">
            <div>
              <i class="far fa-hospital text-verde"></i>
              <span>{{ $t('solution.bloque2.dato1') }}</span>
            </div>
            <div>
              <i class="fas fa-globe-americas text-verde"></i>
              <span>{{ $t('solution.bloque2.dato2') }}</span>
            </div>
            <div>
              <i class="far fa-clipboard-list text-verde"></i>
              <span>{{ $t('solution.bloque2.dato3') }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Solution'
}
</script>

<style lang="scss" scoped>
.solution {
  position: relative;
  width: 100%;
  background: url(../assets/bg-solution.png) no-repeat bottom left;
  background-size: cover;
  font-size: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  .container {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    text-align: left;
    padding-top: 90px;
    padding-bottom: 110px;

    > div {
      width: 100%;
    }

    .title {
      max-width: 1000px;
      font-weight: 700;
      font-size: 36px;
      margin: 0 auto 40px;
      color: #444D67;
      text-align: center;
    }

    .subtitle {
      max-width: 1000px;
      font-size: 24px;
      margin: 0 auto 60px;
      text-align: center;
    }

    .box-container {
      display: flex;
      justify-content: space-between;

      .box {
        width: calc(100% - 30px);
        background: #FFFFFF;
        padding: 30px 25px;
        font-size: 16px;
        box-shadow: 0px 0px 60px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        text-align: left;

        &:first-child {
          margin-right: 30px;
        }
        &:last-child {
          margin-left: 30px;
        }

        .title {
          font-weight: 700;
          font-size: 24px;
          margin-bottom: 25px;
          text-align: left;
        }

        .box-content > div {
          display: flex;
          align-items: flex-start;
          justify-content: space-between;
          margin-bottom: 30px;

          &:last-child {
            margin-bottom: 0;
          }

          i {
            width: 40px;
            font-size: 25px;
          }

          span {
            width: calc(100% - 40px);
          }
        }
      }
    }
  }
}

@media(max-width: 1150px) {
  .solution {
    font-size: 14px;

    .container .title {
      font-size: 32px;
    }

    .container .subtitle {
      font-size: 20px;
    }

    .container .box-container .box {
      font-size: 14px;

      .title {
        font-size: 20px;
      }
    }
  }
}

@media(max-width: 900px) {
  .solution {

    .container .title {
      font-size: 28px;
    }

    .container .subtitle {
      font-size: 17px;
    }

    .box-container .box .title {
      font-size: 19px;
    }
  }
}

@media(max-width: 770px) {
  .solution {

    .container .box-container {
      flex-wrap: wrap;

      .box {
        width: 100%;

        &:first-child {
          margin: 0 0 25px;
        }

        &:last-child {
          margin: 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/solution.vue